import Layout from "./Partials/Layout";

const Dashboard = () => {

    return (
        <Layout>
            <h4>
                Welcome
            </h4>
        </Layout>
    )
}

export default Dashboard;
